export const CONTAINER_WIDTH = {
  mobile: 480,
  tablet: 800,
  desktop: 1040,
};

export default {
  mobile: `@media screen and (min-width: ${CONTAINER_WIDTH.mobile}px)`,
  tablet: `@media screen and (min-width: ${CONTAINER_WIDTH.tablet}px)`,
  desktop: `@media screen and (min-width: ${CONTAINER_WIDTH.desktop}px)`,
};
